const useRedirectTo = (): string | null => {
  const redirectTo = new URLSearchParams(location.search).get('redirectTo')
  const redirectPath = typeof redirectTo === 'string' ? redirectTo : null

  return redirectPath
}

export default useRedirectTo
